import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
        FETCH_INDIVIDUAL_MEMBERSHIP,
        individualMembershipReceived,
        MembershipCertificateReceived,
        GENERATE_MEMBERSHIP_CERETIFICATE, 
        EDIT_MEMBERSHIP,
        hasEditedMembership,
        fileReceived,
        startLoading,
        stopLoading
} from '../actions'

import {
    GENERATE_CERTIFICATE_LOADING_ID,
    EDIT_MEMBERSHIP_LOADING_ID
} from '../store/loaders'


function * fetchIndividualMembership (paylaod){
    try{
       const response=  yield call(DCore.get, `/members/memberships/users/${paylaod.data}`,true)
        yield put (individualMembershipReceived(response.data))

    }catch(e){
        console.log(e)
    }
}

function * generateMembershipCertificate (paylaod){
    yield put(startLoading({id:GENERATE_CERTIFICATE_LOADING_ID}))
    try{
       const response=  yield call(DCore.get, `/members/memberships/file?filePath=${paylaod.data}`,true)
        yield put(stopLoading({id:GENERATE_CERTIFICATE_LOADING_ID}))
        yield put (fileReceived(response.data))

    }catch(e){
        yield put(stopLoading({id:GENERATE_CERTIFICATE_LOADING_ID}))
        console.log(e)
    }
}

function * editMembership (paylaod){
    yield put(startLoading({id:EDIT_MEMBERSHIP_LOADING_ID}))
    try{
       const response=  yield call(DCore.put, `/members/individuals/update/${paylaod.data.id}`,paylaod.data.application)
        yield put(stopLoading({id:EDIT_MEMBERSHIP_LOADING_ID}))
        yield put (hasEditedMembership(paylaod.data.reqId))

    }catch(e){
        yield put(stopLoading({id:EDIT_MEMBERSHIP_LOADING_ID}))
        console.log(e)
    }
}



export function * membershipSaga(){
    yield takeLatest(FETCH_INDIVIDUAL_MEMBERSHIP,fetchIndividualMembership)
    yield takeLatest(GENERATE_MEMBERSHIP_CERETIFICATE,generateMembershipCertificate)
    yield takeLatest(EDIT_MEMBERSHIP,editMembership)

}